<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24">
    <g>
      <polygon
        points="15.5 14.5 15.5 1.5 0.5 1.5 0.5 19.5 7.5 19.5 7.5 23.5 22.5 23.5 22.5 14.5 15.5 14.5"
        fill="#fff" />
      <polygon
        points="12.5 1.5 3.5 19.5 7.5 14.5 12.5 14.5 12.5 1.5"
        class="st1" />
      <polygon
        points="7.5 14.5 7.5 19.5 3.5 19.5 7.5 14.5"
        class="st1" />
      <polygon
        points="19.5 14.5 10.5 23.5 19.5 23.5 19.5 14.5"
        class="st1" />
      <polyline
        points="3.5 19.5 0.5 19.5 0.5 1.5 3.5 1.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <polyline
        points="12.5 12.5 12.5 1.5 3.5 1.5 3.5 19.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <polyline
        points="15.5 12.5 15.5 1.5 12.5 1.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <rect
        x="10.5"
        y="14.5"
        width="9"
        height="9"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <rect
        x="7.5"
        y="14.5"
        width="3"
        height="9"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <rect
        x="19.5"
        y="14.5"
        width="3"
        height="9"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <line
        x1="15.5"
        y1="7.5"
        x2="0.5"
        y2="7.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <line
        x1="5.5"
        y1="13.5"
        x2="0.5"
        y2="13.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <line
        x1="0.5"
        y1="4.5"
        x2="3.5"
        y2="4.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <line
        x1="0.5"
        y1="10.5"
        x2="3.5"
        y2="10.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <line
        x1="12.5"
        y1="4.5"
        x2="15.5"
        y2="4.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <line
        x1="12.5"
        y1="10.5"
        x2="15.5"
        y2="10.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <line
        x1="0.5"
        y1="16.5"
        x2="3.5"
        y2="16.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <line
        x1="7.5"
        y1="20.5"
        x2="10.5"
        y2="20.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <line
        x1="7.5"
        y1="17.5"
        x2="10.5"
        y2="17.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <line
        x1="19.5"
        y1="20.5"
        x2="22.5"
        y2="20.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <line
        x1="19.5"
        y1="17.5"
        x2="22.5"
        y2="17.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <line
        x1="7.5"
        y1="14.5"
        x2="3.5"
        y2="19.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <line
        x1="3.5"
        y1="19.5"
        x2="7.5"
        y2="19.5"
        fill="none"
        class="st2"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  .st1 {
    fill: var(--iconColorExtraLight);
  }

  .st2 {
    stroke: var(--iconColor);
  }
</style>
